export default {
  forgot_password: {
    title: 'Atur ulang kata sandi',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Lupa kata sandi',
    password_reset_text: 'Masukkan alamat email Anda. Anda akan menerima email konfirmasi untuk mengatur ulang kata sandi Anda.',
    submit: 'Kirim',
    mail_address: 'Isi alamat email',
    input_label: '@:settings.user.email',
  },
}
